import {Component, Input} from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'pt-widget-html-v0-preview',
  template: `
    <ng-container *ngIf="loading; then LOADING; else PREVIEW"></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf="!previewData; then NODATA; else DATA"></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel" *ngIf="showNoData" ></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <div [innerHTML]="previewData"></div>
      </ng-template>
    </ng-template>
  `
})
export class WidgetHtmlV0PreviewComponent {
  @Input() noDataLabel?: string;
  @Input() previewData: string;
  @Input() loading: boolean;
  @Input() showNoData: boolean;
}
